<div class="input-group input-group-sm">
    <div class="input-group-prepend"><span class="input-group-text">#</span></div>
    <input class="form-control form-control-sm text-right" type="text" placeholder="0" autocomplete="off" [id]="id" [formControl]="control" (keydown)="keydown($event)" (blur)="blur($event)" (focus)="focus($event)" />
</div>